import { Plus, Share2 } from 'lucide-react';
import { TableActionMenu, type TableActionItem } from '@/components/shared';
import { useMediaQuery } from '@/lib/use-media-query';

export interface OrganizationsPageActionsProps {
  onCreateOrganization: () => void;
  onCopyShareLink: () => void;
}

export function OrganizationsPageActions({
  onCreateOrganization,
  onCopyShareLink,
}: OrganizationsPageActionsProps) {
  const isMobile = useMediaQuery('(max-width: 767px)');

  const createAction: TableActionItem = {
    id: 'create-organization',
    label: 'Create new organization',
    icon: Plus,
    onSelect: onCreateOrganization,
  };
  const copyShareLinkAction: TableActionItem = {
    id: 'copy-share-link',
    label: 'Copy share link',
    icon: Share2,
    onSelect: onCopyShareLink,
  };

  if (isMobile) {
    return (
      <TableActionMenu
        actions={[createAction, copyShareLinkAction]}
        label="Organization page actions"
      />
    );
  }

  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        className="focus-ring inline-flex h-10 items-center gap-1.5 whitespace-nowrap rounded-lg border border-backoffice-500 bg-backoffice-500 px-3 text-small font-medium text-white hover:bg-backoffice-600"
        onClick={onCreateOrganization}
      >
        <Plus className="h-4 w-4" aria-hidden="true" />
        Create new organization
      </button>
      <TableActionMenu actions={[copyShareLinkAction]} label="Organization page actions" />
    </div>
  );
}
